/**
 * created by li si yi
 * 线索待办处理
 */
import React from 'react';
import {connect} from "react-redux";
import BaseComponent, {contentParser} from "../../../../../base/BaseComponent";
import DetailsModal from "../../../../sysManagement/selectedTopicManagement/components/detailsModal";

class Yuegaowr extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            configKey: ""
        }
    }

    componentWillMount() {
    }

    componentDidMount() {

    }

    data = {};

    isSupport(data) {
        this.data = data;
        if (this.data && this.data.data && this.data.data.id && this.data.activitiCategoryKey === "yuegaowr") {
            return true;
        }
        return false;
    };
    getIcon = (data) => {
        let icon = 'Approximations';
        return icon
    };
    //刷新回调
    handle = (data, call) => {
        // busAppointmentReceiver busAppointment
        let busName = 'busAppointment' || data?.data?.busName;
        if(busName) {
            this.setState({configKey:busName},()=>{
                // let showBtn = true;
                // let userId = window.currentUser?.id;
                // let deptId = window.currentUser?.defaultInfo?.dept?.id;
                // switch (busName) {
                //     case "busAppointmentReceiver":
                //         // 领取者视角
                //         showBtn = (()=>{
                //             let candidateInfo = data?.candidateInfo || [];
                //             return candidateInfo.some(item=>item.userId===userId && item.deptId===deptId)
                //         })();
                //         break;
                //     case "busAppointment":
                //         // 创建者视角
                //         showBtn = (()=>{
                //             let createUserInfo = data?.createUserInfo || {};
                //             return createUserInfo?.userId === userId && createUserInfo?.deptId === deptId
                //         })();
                //         break;

                // }
                // this.details.show(data?.data?.id,{id:data?.data?.id,appointmentId:data?.data?.appointmentId,showBtn:showBtn});
                this.details.show(data?.data?.appointmentId || data?.data?.id,{});
                this.call=call;
            })
        }
    };

    call=null;

    render() {
        return (
            <div style={{display: 'none'}}>
                {this.detailsModal()}
            </div>
        )
    }
    //详情页面弹窗
    detailsModal = () => {
        // 获取领取约稿管理的配置项
        let sysConfigData = JSON.parse(this.sysConfigGetValueByKey(this.state.configKey, '{}'));
        contentParser(sysConfigData, sysConfigData);
        return JSON.stringify(sysConfigData) === "{}" ? <></> : (
            <DetailsModal
                sysConfigData={sysConfigData}
                ref={(details) => {
                    this.details = details
                }}
                callBack={() => {
                    setTimeout(() => {
                        this.call && this.call();
                    }, 2000)
                }}
                details={"约稿详情"}
            />
        )
    };
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
    }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(Yuegaowr)